import { Validators } from "@angular/forms";
import { FieldEnum, IFormField, SubFieldEnum } from "../../shared/models/form-field";

export const ONLY_NUMBER_PATTERN = /^[0-9]\d*$/;
export const RUN_PPC_FORMFIELDS: Array<IFormField> = [
    {
        fieldName: "line_item_number",
        displayName: "Line Item Number",
        defaultValue: "",
        labelName: "Line Item Number",
        placeholder: "Line Item Number",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: true
    },
    {
        fieldName: "IP_MATERIAL_NUMBER",
        displayName: "Material/Service Number",
        defaultValue: "",
        labelName: "Material/Service Number",
        placeholder: "Material/Service Number",
        validators: [Validators.required, Validators.pattern(/^([a-zA-Z0-9]*)$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: true
    },
    {
        fieldName: "IP_VENDOR_NUMBER",
        displayName: "Vendor Number",
        defaultValue: "",
        labelName: "Vendor Number",
        placeholder: "Vendor Number;",
        validators: [Validators.required, Validators.pattern(/^([a-zA-Z0-9]*)$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: true
    }
]